module.exports = __webpack_public_path__ + "img/verify5.731e7e4d.jpg";